import React from 'react';
import { bool, node, object, string } from 'prop-types';
import styled from 'styled-components';

import { isEmpty } from 'ravenjs/utils/lodash';

import { DEFAULT_COLORS } from 'constants/colors';
import { TYPE_AHEAD_FILTER } from 'constants/filters';

const TypeAheadContainerStyled = styled.div`
    background-color: ${DEFAULT_COLORS.WHITE};
    border: 1px solid ${DEFAULT_COLORS.LIGHTEST};
    box-shadow: 0 9px 11px 0 rgba(0, 0, 0, 0.24);
    font-family: Roboto;
    font-size: 0.875rem;
    max-height: 24rem;
    overflow-x: hidden;
    overflow-y: auto;
    position: absolute;
    width: ${({ containerWidth }) => containerWidth};
    z-index: 1;
    & ul {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }
`;

const IsLoadingContainerStyled = styled.div`
    background-color: ${DEFAULT_COLORS.WHITE};
    border: 1px solid ${DEFAULT_COLORS.LIGHTEST};
    box-shadow: 0 9px 11px 0 rgba(0, 0, 0, 0.24);
    color: ${DEFAULT_COLORS.PLACEHOLDER};
    font-family: Roboto;
    font-size: 0.875rem;
    padding: 0.5rem 1rem;
    position: absolute;
    width: ${({ containerWidth }) => containerWidth};
    z-index: 1;
`;

const TypeAheadContainer = ({
    children,
    containerProps,
    containerWidth,
    isLoading,
    isNoResultFound,
    showTypeAheadContainer,
}) => {
    return (
        (isLoading && showTypeAheadContainer && (
            <IsLoadingContainerStyled containerWidth={containerWidth} {...containerProps}>
                {TYPE_AHEAD_FILTER.LOADING}
            </IsLoadingContainerStyled>
        )) ||
        (isNoResultFound && !isLoading && showTypeAheadContainer && isEmpty(children) && (
            <IsLoadingContainerStyled containerWidth={containerWidth} {...containerProps}>
                {TYPE_AHEAD_FILTER.NO_RESULTS_FOUND}
            </IsLoadingContainerStyled>
        )) ||
        (children && showTypeAheadContainer && (
            <TypeAheadContainerStyled containerWidth={containerWidth} {...containerProps}>
                {children}
            </TypeAheadContainerStyled>
        )) ||
        null
    );
};

TypeAheadContainer.propTypes = {
    children: node,
    containerProps: object,
    containerWidth: string,
    isLoading: bool,
    isNoResultFound: bool,
    showTypeAheadContainer: bool,
};

TypeAheadContainer.defaultProps = {
    children: null,
    containerProps: {},
    containerWidth: '200px',
    isLoading: false,
    isNoResultFound: false,
    showTypeAheadContainer: true,
};

export default TypeAheadContainer;
